import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";

import { ILinkProps } from "./types";

export const Link: FC<ILinkProps> = (props) => {
  const classes = classNames("navbar__link", props.className);

  return (
    <NavLink className={classes} to={props.to}>
      {props.children}
    </NavLink>
  );
};

Link.defaultProps = {
  to: "",
  children: null,
};
